// Which Georgia county a ZIP is in — a suggestion for the county field, never a
// decision. Whoever is filling the form can always pick a different county.
//
// Why: a county left blank or entered wrongly silently drops a child off the
// Service Counties map and out of the approved-area check. On 2026-10-13 two
// active clients had no county at all, and one (G046, Atlanta 30340) was
// recorded as Fulton for a ZIP with no Fulton in it — it is DeKalb and Gwinnett.
//
// Source: U.S. Census Bureau, 2020 ZCTA-to-county relationship file
// (tab20_zcta520_county20_natl.txt), trimmed to Georgia's 752 ZIPs and
// generated into gaZipCounty.json. County names match gaCountyGeo.json exactly.
//
// Georgia's rural ZIPs are large, and about four in ten cross a county line,
// so treating every crossing as "ask" would make this useless half the time.
// Most crossings are lopsided — Cedartown 30125 is 97% Polk — so:
//   - one county holding at least 90% of the ZIP's land  → that county ("fill")
//   - otherwise → the counties holding at least 5% each   ("choose")
// Land area is not population, which is exactly why a crossing ZIP is offered
// as a short list rather than guessed. Checked against the 33 active clients
// before shipping: 32 agreed, the one that did not was G046.
//
// A ZIP that is not in the table (PO boxes, some hospital and business ZIPs)
// returns 'unknown' and the form simply leaves the choice to the person.
import table from './gaZipCounty.json';

/**
 * @returns {{ kind: 'fill' | 'choose' | 'unknown', counties: string[] }}
 */
export function countyForZip(zip) {
  const key = String(zip || '').replace(/\D/g, '').slice(0, 5);
  if (key.length !== 5) return { kind: 'unknown', counties: [] };
  const hit = table[key];
  if (!hit) return { kind: 'unknown', counties: [] };
  return Array.isArray(hit)
    ? { kind: 'choose', counties: hit }
    : { kind: 'fill', counties: [hit] };
}
